module.exports = __webpack_public_path__ + "static/img/DeluxeFamilyRoom4.d041d267.jpg";